import React, { useEffect, useState } from 'react';
import style from './DirectApplication.style';
import { Button } from 'reactstrap';
import RezRateImg from '../../../../assets/images/header/rezRate.gif';
import { useHistory } from 'react-router';
import { useLocation } from 'react-router-dom';
import ApplicationLogin from './ApplicantLogin/ApplicantLogin';
import ApplicantLogin from './ApplicantLogin/ApplicantLogin';
import ApplicantProfile from './ApplicantProfile/ApplicantProfile';
import CreateApplicantAccount from './CreateApplicantAccount/CreateApplicantAccount';
import ApplicantHeader from './ApplicantHeader/ApplicantHeader';
import { useKindeAuth } from '@kinde-oss/kinde-auth-react';
import { fetchData, fetchDataAgnostic } from 'Services/dataApi';
import { formatBearerToken } from 'Common.functions';

const DirectApplication = () => {
  const [isLoggedIn, setIsLoggedIn] = useState(false); // Temporary state
  const [departmentData, setDepartmentData] = useState();
  const [showMode, setShowMode] = useState('landing'); // Temporary state

  const [departments, setDepartments] = useState([]);

  const history = useHistory();
  const { pathname, search } = history.location;

  const { isAuthenticated, login, getToken, isLoading, register } = useKindeAuth();
  const query = new URLSearchParams(useLocation().search);

  const codeFromURL = query.get('applicationCode');

  useEffect(() => {
    if (login && !isLoading) {
      if (isAuthenticated) {
        const codeToRedirect = localStorage.getItem('applicationCodeToReturn');

        if (codeToRedirect) {
          localStorage.removeItem('applicationCodeToReturn');
          history.push(`/applicant/profile/new_application?applicationCode=${codeToRedirect}`);
          setShowMode('profile');
        }

        // history.push('/applicant/profile');
        // getDepartments();
      } else {
        // handleLogin();
        // login(); // go to login
        // register();
      }
    } else {
      ///applicant/profile/new_application?applicationCode
    }
  }, [login, isLoading]);

  useEffect(() => {
    if (codeFromURL) {
      getDepartmentDetails(codeFromURL);
    }
  }, [codeFromURL]);

  useEffect(() => {
    if (isAuthenticated) {
      if (pathname.indexOf('/login') >= 0) {
        setShowMode('login');
      } else if (pathname.indexOf('/profile') >= 0) {
        setShowMode('profile');
      } else if (pathname.indexOf('/create_account') >= 0) {
        setShowMode('create_account');
      } else {
        setShowMode('profile');
      }
    } else {
      setShowMode('landing');
    }
  }, [pathname]);

  const getDepartmentDetails = (codeFromURL) => {
    fetchDataAgnostic(`department/application/${codeFromURL}`, null, null)
      .then((res) => {
        if (res.data) {
          setDepartmentData(res.data);
        }
      })
      .catch((err) => {
        console.log('err: ', err);
      });
  };

  const renderLogin = () => {
    return <ApplicantLogin setShowMode={setShowMode} />;
  };

  const renderProfile = () => {
    return (
      <ApplicantProfile
        setShowMode={setShowMode}
        departmentData={departmentData}
        getDepartmentDetails={getDepartmentDetails}
      />
    );
  };

  const renderCreateApplicantAccount = () => {
    return <CreateApplicantAccount setShowMode={setShowMode} />;
  };

  const renderLanding = () => {
    return (
      <div style={{ ...style.simpleRow, width: '100%', height: '100%', alignItems: 'center' }}>
        <div style={{ ...style.simpleColumn, height: '100%' }}>
          <div style={{ ...style.simpleRow, marginBottom: 10 }}>
            <img src={RezRateImg} alt="RezRate Logo" style={{ width: '30vh', height: '30vh' }} />
          </div>
          {renderLogin()}
          {/* <div style={{ ...style.simpleRow, marginBottom: 10 }}>
            <Button
              size="lg"
              color="primary"
              onClick={() => {
                history.push('/applicant/applicant_login');
              }}
            >
              <b>Login</b>
            </Button>
          </div>
          <div style={style.simpleRow}>
            <Button
              size="lg"
              color="success"
              onClick={() => {
                history.push('/applicant/create_applicant_account');
              }}
            >
              <b>Create Application Account</b>
            </Button>
          </div> */}
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (login && !isLoading && !isAuthenticated) {
      const { OrganizationName = '', DepartmentName = '', ProgramType = '', DepartmentLogo } = departmentData || {};

      return (
        <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
          <div style={{ ...style.simpleColumn, marginBottom: 20, width: '100%' }}>
            <div style={{ ...style.simpleRow, marginTop: '10vh' }}>
              <img src={DepartmentLogo ? DepartmentLogo : RezRateImg} style={{ height: '30vh' }} />
            </div>
            <div style={{ ...style.simpleRow, justifyContent: 'center', marginTop: 20 }}>
              {departmentData ? (
                <span>
                  <b>{`${OrganizationName || ''}${`'s`} ${DepartmentName || 'Unnamed Department'}`}</b> would like to
                  invite you to apply to their <b>{`${`${ProgramType}!`}`}</b>
                </span>
              ) : (
                ''
              )}
              {/* {departmentData
                ? `${departmentData.OrganizationName || ''}${`'s`} ${departmentData.DepartmentName ||
                    'Unnamed Department'} would like to invite you to apply to their ${`${departmentData.ProgramType}!` ||
                    'Unnamed Role!'}`
                : ''} */}
            </div>
            <div
              style={{ ...style.simpleRow, borderTop: '2px solid grey', justifyContent: 'center', height: 10 }}
            ></div>
            <div style={{ ...style.simpleRow, justifyContent: 'center' }}>
              <Button
                color="primary"
                style={{ width: 250, marginRight: 10, fontWeight: 'bold' }}
                onClick={() => {
                  if (codeFromURL) {
                    localStorage.setItem('applicationCodeToReturn', codeFromURL);
                  }

                  login();
                }}
              >
                Let's get it started!
              </Button>
              {/* <Button
                color="success"
                style={{ width: 250, fontWeight: 'bold' }}
                onClick={() => {
                  localStorage.setItem('applicationCodeToReturn', codeFromURL);
                  register();
                }}
              >
                Click to create an account and apply
              </Button> */}
            </div>
          </div>
        </div>
      );
    } else {
      switch (showMode) {
        case 'login':
          return renderLogin();
        case 'profile':
          return renderProfile();
        case 'create_account':
          return renderCreateApplicantAccount();
        default:
          return renderProfile();
      }
    }
  };

  return (
    <div
      style={{
        ...style.simpleRow,
        width: '100%',
        height: 'calc(100vh - 80px)',
        alignItems: 'flex-start',
      }}
    >
      <div style={{ ...style.simpleColumn }}>
        {<ApplicantHeader isAuthenticated={isAuthenticated} showMode={showMode} />}
        {renderContent()}
      </div>
    </div>
  );
};

export default DirectApplication;
